<div class="mct-flex mct-col mct-gap-27">
  <div class="mct-flex mct-col" *ngIf="eCommerceItem">
    <label>{{ 'ecommerce.item.search-keywords' | translate | ucfirst }}</label>
    <div class="keywords-container">
      <p-chip *ngFor="let keyword of keywords" [label]="keyword" [removable]="true" (onRemove)="removeKeyword(keyword)">
      </p-chip>
      <input
        type="text"
        class="keyword-input"
        [(ngModel)]="newKeyword"
        (keydown.enter)="addKeyword($event)"
        (blur)="addKeywordOnBlur()"
      />
    </div>
  </div>
</div>
